export const fieldLabelClass =
  'font-label text-[12px] sm:text-[13px] font-semibold uppercase tracking-wide text-muted-foreground';

export const fieldDescriptionClass =
  'text-[12px] sm:text-[13px] text-muted-foreground';
